import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getInvoiceFromUuid } from "data/server_apis/reportService";

const initialState = {
  uuid: null,
  loading: false,
  success: false,
  error: false,
  data: null,
};

export const getInvoicePdfThunk = createAsyncThunk(
  "invoice/getPdf",
  async (uuid, { rejectWithValue }) => {
    try {
      return (await getInvoiceFromUuid(uuid)).data;
    } catch (err) {
      const customError = {
        name: err.response?.status,
        message: err.response?.status === 400 ? err.response?.data : null,
      };
      // console.log("Error", customError);
      return rejectWithValue(customError);
    }
  }
);

const invoiceSlice = createSlice({
  name: "invoice_pdf",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getInvoicePdfThunk.pending, (state, action) => {
        state.uuid = null;
        state.data = null;
        state.error = false;
        state.success = false;
        state.loading = true;
      })
      .addCase(getInvoicePdfThunk.rejected, (state, action) => {
        state.uuid = null;
        state.data = null;
        state.error = true;
        state.success = false;
        state.loading = false;
      })
      .addCase(getInvoicePdfThunk.fulfilled, (state, action) => {
        state.uuid = action.meta.arg;
        state.data = action.payload;
        state.error = false;
        state.success = true;
        state.loading = false;
      });
  },
});

export const {} = invoiceSlice.actions;

export default invoiceSlice.reducer;
